import embedTableauView from './embedTableauComponent.html';
import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import './embedTableauComponent.css';
import _ from 'lodash';

export function embedTableauComponent() {
	return {
		bindings: {
			embed: '<',
		},
		controllerAs: 'vm',
		controller: embedTableauComponentCtrl,
		template: embedTableauView,
	};
}

export class embedTableauComponentCtrl {
	constructor($element) {
		'ngInject';
		this.$element = $element;
		this.scriptPromise = AssetManager.script('https://public.tableau.com/javascripts/api/tableau-2.2.2.js');
		this.scriptPromise.then(
			() => {
				this.load();
			},
			() => {
				this.error = true;
			}
		);
	}

	/**
	 * Use Tableau's JS SDK to embed the chart.
	 * @see https://onlinehelp.tableau.com/current/api/js_api/en-us/JavaScriptAPI/js_api.htm
	 */
	load() {
		// JS object that points at empty div in the html
		const placeholderDiv = this.$element[0].querySelector('.embed-container');
		// An object that contains options specifying how to embed the viz
		const options = {
			hideTabs: true,
			hideToolbar: true,
		};
		if (this.embed.width) {
			options.width = this.embed.width;
		}
		if (this.embed.height) {
			options.height = this.embed.height;
		}
		let advanced = {};
		try {
			advanced = JSON.parse(this.embed.advanced || '{}') || {};
		} catch (e) {}
		const finalOptions = _.defaultsDeep(advanced, options);
		new window.tableau.Viz(placeholderDiv, this.embed.url, finalOptions);
	}
}
